<app-menu></app-menu>

<section class="controlsafe-page" *ngIf="tenantId; else emptyState">
  <aside class="safe-sidebar">
    <section class="sidebar-summary">
      <button type="button" class="section-toggle" (click)="toggleSummaryPanel($event)">
        <div class="summary-head summary-head--compact"></div>
        <mat-icon>{{ summaryExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      <div class="sidebar-summary__body" *ngIf="summaryExpanded">
        <div class="security-overview">
          <div class="security-score" [style.--score]="securityScore">
            <strong>{{ securityScore }}%</strong>
          </div>
          <div class="security-copy">
            <strong>{{ passwordStrengthLabel }}</strong>
            <span>{{ passwordStrengthCopy }}</span>
          </div>
        </div>

        <nav class="sidebar-nav" aria-label="Navegação do ControlSafe">
          <button type="button" class="sidebar-nav__item" [class.active]="sidebarSection === 'overview'" (click)="setSidebarSection('overview', $event)">
            <mat-icon>dashboard</mat-icon>
            <span>Visão geral</span>
          </button>
          <button type="button" class="sidebar-nav__item" [class.active]="sidebarSection === 'folders'" (click)="setSidebarSection('folders', $event)">
            <mat-icon>folder</mat-icon>
            <span>Cofres</span>
          </button>
          <button type="button" class="sidebar-nav__item" [class.active]="sidebarSection === 'items'" (click)="setSidebarSection('items', $event)">
            <mat-icon>inventory_2</mat-icon>
            <span>Itens</span>
          </button>
          <button type="button" class="sidebar-nav__item" [class.active]="sidebarSection === 'shared'" (click)="setSidebarSection('shared', $event)">
            <mat-icon>share</mat-icon>
            <span>Compartilhados</span>
          </button>
          <button type="button" class="sidebar-nav__item" [class.active]="sidebarSection === 'expiring'" (click)="setSidebarSection('expiring', $event)">
            <mat-icon>schedule</mat-icon>
            <span>Credenciais expirando</span>
          </button>
        </nav>

        <section class="sidebar-panel sidebar-favorites">
          <div class="section-head section-head--compact">
            <p>Favoritos</p>
            <span class="section-meta">{{ favoriteItems.length + (currentVault ? favoriteFolders.length : favoriteVaults.length) }}</span>
          </div>

          <div class="sidebar-favorites__group" *ngIf="favoriteItems.length">
            <span class="sidebar-favorites__label">Itens favoritos</span>
            <button
              type="button"
              class="nav-item sidebar-favorites__item"
              *ngFor="let item of favoriteItems; trackBy: trackByFavoriteRowId"
              (click)="openItemDetail(item)">
              <div class="item-info">
                <mat-icon>{{ getItemIcon(item.item_type) }}</mat-icon>
                <div>
                  <strong [title]="item.title">{{ item.title }}</strong>
                </div>
              </div>
              <mat-icon class="sidebar-favorites__star">star</mat-icon>
            </button>
          </div>

          <div class="sidebar-favorites__group" *ngIf="currentVault; else favoriteVaultsBlock">
            <span class="sidebar-favorites__label">{{ favoriteContainersLabel }}</span>
            <button
              type="button"
              class="nav-item sidebar-favorites__item"
              *ngFor="let container of favoriteFolders; trackBy: trackByFolderId"
              (click)="openFolder(container)">
              <div class="item-info">
                <mat-icon>folder</mat-icon>
                <div>
                  <strong [title]="container.name">{{ container.name }}</strong>
                </div>
              </div>
              <mat-icon class="sidebar-favorites__star">star</mat-icon>
            </button>
          </div>

          <ng-template #favoriteVaultsBlock>
            <div class="sidebar-favorites__group" *ngIf="favoriteVaults.length">
              <span class="sidebar-favorites__label">{{ favoriteContainersLabel }}</span>
              <button
                type="button"
                class="nav-item sidebar-favorites__item"
                *ngFor="let container of favoriteVaults; trackBy: trackByVaultId"
                (click)="openVault(container)">
                <div class="item-info">
                  <mat-icon>folder</mat-icon>
                  <div>
                    <strong [title]="container.name">{{ container.name }}</strong>
                  </div>
                </div>
                <mat-icon class="sidebar-favorites__star">star</mat-icon>
              </button>
            </div>
          </ng-template>
        </section>
      </div>
    </section>

  </aside>

  <main class="safe-main">
    <section class="metrics-grid">
      <article class="metric-card" *ngFor="let metric of dashboardMetricCards" [attr.data-tone]="metric.tone">
        <div class="metric-copy">
          <p>{{ metric.label }}</p>
          <strong>{{ metric.value }}</strong>
          <small>{{ metric.hint }}</small>
        </div>
        <div class="metric-icon">
          <mat-icon>{{ metric.icon }}</mat-icon>
        </div>
      </article>
    </section>

    <section class="panel panel--items">
      <header class="panel-head panel-head--items">
        <div class="panel-head__title">
          <h3>{{ mainSectionTitle }}</h3>
          <span class="panel-count">{{ mainSectionCount }} {{ sidebarSection === 'folders' ? (currentVault ? 'pastas' : 'cofres') : 'itens' }}</span>
        </div>
      </header>

      <div class="items-toolbar">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field cp-search-field safe-search-field items-search-field">
          <mat-label>{{ mainSearchLabel }}</mat-label>
          <mat-icon matIconPrefix>search</mat-icon>
          <input
            matInput
            type="search"
            [placeholder]="mainSearchLabel"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onItemSearchChange($event)">
        </mat-form-field>

        <div class="items-toolbar__actions">
          <div class="split-create">
            <button class="btn primary split-create__main" type="button" (click)="toggleQuickCreateMenu($event)">
              <mat-icon>add</mat-icon>
              Novo
            </button>
            <div class="quick-create-menu" *ngIf="showQuickCreateMenu" (click)="$event.stopPropagation()">
              <button type="button" (click)="openVaultModal(); closeQuickCreateMenu($event)">
                <mat-icon>folder</mat-icon>
                <span>Novo cofre</span>
              </button>
              <button type="button" (click)="openItemModal(); closeQuickCreateMenu($event)">
                <mat-icon>description</mat-icon>
                <span>Novo item</span>
              </button>
              <button type="button" (click)="openFolderModal(); closeQuickCreateMenu($event)">
                <mat-icon>create_new_folder</mat-icon>
                <span>Nova pasta</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="safe-table-wrap" *ngIf="sidebarSection !== 'folders'; else foldersListView">
        <table class="safe-table">
          <colgroup>
            <col class="col-item">
            <col class="col-type">
            <col class="col-location">
            <col class="col-user">
            <col class="col-link">
            <col class="col-password">
            <col class="col-expiry">
            <col class="col-strength">
          </colgroup>
          <thead>
            <tr>
              <th>
                <button type="button" class="sort-header" [class.active]="isItemSortActive('title')" (click)="setItemSort('title')">
                  <span>Item</span>
                  <mat-icon>{{ itemSortColumn === 'title' && itemSortDirection === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                </button>
              </th>
              <th>
                <button type="button" class="sort-header" [class.active]="isItemSortActive('item_type')" (click)="setItemSort('item_type')">
                  <span>Tipo</span>
                  <mat-icon>{{ itemSortColumn === 'item_type' && itemSortDirection === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                </button>
              </th>
              <th>Local</th>
              <th>
                <button type="button" class="sort-header" [class.active]="isItemSortActive('username')" (click)="setItemSort('username')">
                  <span>Usuário</span>
                  <mat-icon>{{ itemSortColumn === 'username' && itemSortDirection === 'desc' ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
                </button>
              </th>
              <th>Link</th>
              <th>Senha</th>
              <th>Expira em</th>
              <th>Força</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedItems" (click)="openItemFromRow(item, $event)">
              <td class="name-cell">
                <div class="safe-primary-cell">
                  <div class="item-icon-badge" [attr.data-type]="item.item_type">
                    <mat-icon>{{ getItemIcon(item.item_type) }}</mat-icon>
                  </div>
                  <button
                    *ngIf="canFavoriteItem(item)"
                    class="favorite-inline table-favorite"
                    type="button"
                    (click)="toggleFavorite(item, $event)"
                    [class.inactive]="!item.is_favorite"
                    aria-label="Favoritar item">
                    <mat-icon>{{ item.is_favorite ? 'star' : 'star_border' }}</mat-icon>
                  </button>
                  <div class="safe-primary-cell__content">
                    <strong>{{ item.title }}</strong>
                    <small *ngIf="item.subtitle">{{ item.subtitle }}</small>
                  </div>
                </div>
              </td>
              <td><span class="type-pill" [attr.data-type]="item.item_type">{{ getItemTypeLabel(item.item_type) }}</span></td>
              <td class="location-cell">{{ item.location_label || 'Raiz' }}</td>
              <td>
                <span class="cell-text">{{ item.username || '—' }}</span>
              </td>
              <td class="link-cell">
                <div class="cell-actions">
                  <ng-container *ngIf="item.website_url; else noLink">
                    <a class="link-label" [href]="item.website_url" target="_blank" rel="noopener" (click)="$event.stopPropagation()">Link</a>
                  </ng-container>
                  <ng-template #noLink>
                    <span class="link-label muted">—</span>
                  </ng-template>
                  <button
                    class="icon-button copy"
                    type="button"
                    (click)="copyToClipboard(item.website_url); $event.stopPropagation()"
                    [disabled]="!item.website_url"
                    aria-label="Copiar link">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </td>
              <td class="password-cell">
                <div class="cell-actions">
                  <span class="masked">••••••</span>
                  <button class="icon-button copy" type="button" (click)="copyItemSecret(item, $event)" aria-label="Copiar senha">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </div>
              </td>
              <td>{{ item.expires_at ? (item.expires_at | date: 'shortDate') : '—' }}</td>
              <td>
                <div
                  class="strength-dots"
                  [attr.data-tone]="(item.password_score || 5) >= 4 ? 'success' : 'warning'"
                  [attr.aria-label]="'Força'">
                  <span *ngFor="let dot of [1, 2, 3, 4, 5]" class="strength-dot" [class.active]="dot <= (item.password_score || 5)"></span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <footer class="table-footer table-footer--items">
          <div class="table-footer__pagination" *ngIf="itemTotalPages > 1">
            <span class="table-footer__meta">
              Mostrando {{ itemPageFrom }} - {{ itemPageTo }} de {{ filteredItems.length }}
            </span>
            <button class="mini-action" type="button" (click)="goToItemPage(currentItemPage - 1)" [disabled]="currentItemPage <= 1">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button
              *ngFor="let page of itemPageNumbers"
              type="button"
              class="detail-page-dot"
              [class.active]="currentItemPage === page"
              (click)="goToItemPage(page)">
              {{ page }}
            </button>
            <button class="mini-action" type="button" (click)="goToItemPage(currentItemPage + 1)" [disabled]="currentItemPage >= itemTotalPages">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </footer>
      </div>
    </section>

    <section class="panel" *ngIf="currentVault && sidebarSection !== 'folders'">
      <header class="panel-head">
        <div>
          <h3>Pastas</h3>
          <small>{{ filteredFolders.length }} itens</small>
        </div>
      </header>

      <div class="vault-list-table" *ngIf="filteredFolders.length; else noFolders">
        <div class="vault-list-table__header">
          <span class="vault-list-table__name">Nome</span>
          <span class="vault-list-table__count">Itens</span>
          <span class="vault-list-table__count">Pastas</span>
          <span class="vault-list-table__date">Criação</span>
          <span class="vault-list-table__actions"></span>
        </div>
        <article
          class="vault-list-row"
          *ngFor="let folder of filteredFolders; trackBy: trackByFolderId"
          role="button"
          tabindex="0"
          (click)="openFolderFromRow(folder, $event)"
          (keydown.enter)="openFolderFromRow(folder, $event)"
          (keydown.space)="$event.preventDefault(); openFolderFromRow(folder, $event)">
          <div class="vault-list-row__name">
            <button
              *ngIf="canFavoriteFolder(folder)"
              type="button"
              class="vault-list-row__favorite"
              (click)="toggleFolderFavorite(folder, $event)"
              [class.inactive]="!folder.is_favorite"
              aria-label="Favoritar pasta">
              <mat-icon>{{ folder.is_favorite ? 'star' : 'star_border' }}</mat-icon>
            </button>
            <div class="folder-list-icon">
              <mat-icon>folder</mat-icon>
            </div>
            <div class="vault-list-row__text">
              <strong>{{ folder.name }}</strong>
            </div>
          </div>
          <span class="vault-list-row__count">{{ folder.item_count || 0 }}</span>
          <span class="vault-list-row__count">{{ folder.folder_count || 0 }}</span>
          <span class="vault-list-row__date">{{ folder.created_at | date: 'dd/MM/yyyy' }}</span>
          <div class="vault-list-row__actions" (click)="$event.stopPropagation()">
            <button class="icon-button action-trigger" type="button" (click)="toggleFolderMenu(folder, $event)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <div class="action-dropdown action-dropdown--vault-list" *ngIf="activeFolderMenuId === folder.id" (click)="$event.stopPropagation()">
              <button type="button" (click)="openFolderModal(folder); closeFolderMenu($event)">
                <mat-icon>edit</mat-icon>
                <span>Renomear</span>
              </button>
              <button type="button" (click)="openShareModal('FOLDER', { id: folder.id, name: folder.name }, $event); closeFolderMenu($event)">
                <mat-icon>share</mat-icon>
                <span>Compartilhar</span>
              </button>
              <button type="button" class="danger" *ngIf="canDeleteFolder(folder)" (click)="deleteFolder(folder, $event); closeFolderMenu($event)">
                <mat-icon>delete</mat-icon>
                <span>Excluir</span>
              </button>
            </div>
          </div>
        </article>
      </div>
    </section>
  </main>
</section>

<ng-template #noVaults>
  <div class="sidebar-empty">Nenhum cofre cadastrado.</div>
</ng-template>

<ng-template #noFolders>
  <div class="folders-empty">
    <div class="folders-empty__art">
      <div class="folders-empty__back"></div>
      <div class="folders-empty__front"></div>
      <div class="folders-empty__spark folders-empty__spark--a"></div>
      <div class="folders-empty__spark folders-empty__spark--b"></div>
      <div class="folders-empty__spark folders-empty__spark--c"></div>
    </div>
    <h4>Nenhuma pasta encontrada</h4>
    <p>Comece criando sua primeira pasta ou adicione um item a este cofre.</p>
    <div class="folders-empty__actions">
      <button class="btn primary" type="button" (click)="openFolderModal()" [disabled]="!currentVault">Nova pasta</button>
      <button class="btn outline" type="button" (click)="openItemModal()">Novo item</button>
    </div>
  </div>
</ng-template>

<ng-template #noItems>
  <div class="panel-empty">Nenhum item encontrado.</div>
</ng-template>

<ng-template #foldersListView>
  <div class="safe-folder-list-view" *ngIf="!currentVault; else currentVaultFoldersView">
    <div class="vault-list-table" *ngIf="filteredVaults.length; else noVaults">
      <div class="vault-list-table__header">
        <span class="vault-list-table__name">Nome</span>
        <span class="vault-list-table__count">Itens</span>
        <span class="vault-list-table__count">Pastas</span>
        <span class="vault-list-table__date">Criação</span>
        <span class="vault-list-table__actions"></span>
      </div>
        <article
          class="vault-list-row"
          *ngFor="let vault of filteredVaults; trackBy: trackByVaultId"
          role="button"
          tabindex="0"
          (click)="openVaultFromRow(vault, $event)"
          (keydown.enter)="openVaultFromRow(vault, $event)"
          (keydown.space)="$event.preventDefault(); openVaultFromRow(vault, $event)">
        <div class="vault-list-row__name">
          <button
            *ngIf="canFavoriteVault(vault)"
            type="button"
            class="vault-list-row__favorite"
            (click)="toggleVaultFavorite(vault, $event)"
            [class.inactive]="!vault.is_favorite"
            aria-label="Favoritar cofre">
            <mat-icon>{{ vault.is_favorite ? 'star' : 'star_border' }}</mat-icon>
          </button>
          <div class="folder-list-icon">
            <mat-icon>folder</mat-icon>
          </div>
          <div class="vault-list-row__text">
            <strong>{{ vault.name }}</strong>
          </div>
        </div>
        <span class="vault-list-row__count">{{ vaultItemCount(vault) }}</span>
        <span class="vault-list-row__count">{{ vaultFolderCount(vault) }}</span>
        <span class="vault-list-row__date">{{ vault.created_at | date: 'dd/MM/yyyy' }}</span>
        <div class="vault-list-row__actions" (click)="$event.stopPropagation()">
          <button class="icon-button action-trigger" type="button" (click)="toggleVaultMenu(vault, $event)">
            <mat-icon>more_vert</mat-icon>
          </button>
          <div class="action-dropdown action-dropdown--vault-list" *ngIf="activeVaultMenuId === vault.id" (click)="$event.stopPropagation()">
            <button type="button" (click)="openVaultModal(vault); closeVaultMenu($event)">
              <mat-icon>edit</mat-icon>
              <span>Renomear</span>
            </button>
            <button type="button" (click)="openShareModal('VAULT', { id: vault.id, name: vault.name }, $event); closeVaultMenu($event)">
              <mat-icon>share</mat-icon>
              <span>Compartilhar</span>
            </button>
            <button type="button" class="danger" *ngIf="canDeleteVault(vault)" (click)="deleteVault(vault, $event); closeVaultMenu($event)">
              <mat-icon>delete</mat-icon>
              <span>Excluir</span>
            </button>
          </div>
        </div>
      </article>
    </div>
  </div>
  <ng-template #currentVaultFoldersView>
    <div class="safe-folder-list-view" *ngIf="currentVault">
      <ng-container *ngIf="vaultFoldersLoading[currentVault.id] && !folderListRows.length; else folderListRowsView">
        <div class="vault-tree__loading">Carregando pastas...</div>
      </ng-container>
      <ng-template #folderListRowsView>
        <div class="vault-list-table" *ngIf="folderListRows.length; else noFolders">
          <div class="vault-list-table__header">
            <span class="vault-list-table__name">Nome</span>
            <span class="vault-list-table__count">Itens</span>
            <span class="vault-list-table__count">Pastas</span>
            <span class="vault-list-table__date">Criação</span>
            <span class="vault-list-table__actions"></span>
          </div>
          <article
            class="vault-list-row"
            *ngFor="let folder of folderListRows; trackBy: trackByFolderId"
            role="button"
            tabindex="0"
            (click)="openFolderFromRow(folder, $event)"
            (keydown.enter)="openFolderFromRow(folder, $event)"
            (keydown.space)="$event.preventDefault(); openFolderFromRow(folder, $event)">
            <div class="vault-list-row__name">
              <button
                *ngIf="canFavoriteFolder(folder)"
                type="button"
                class="vault-list-row__favorite"
                (click)="toggleFolderFavorite(folder, $event)"
                [class.inactive]="!folder.is_favorite"
                aria-label="Favoritar pasta">
                <mat-icon>{{ folder.is_favorite ? 'star' : 'star_border' }}</mat-icon>
              </button>
              <div class="folder-list-icon">
                <mat-icon>folder</mat-icon>
              </div>
              <div class="vault-list-row__text">
                <strong>{{ folder.name }}</strong>
              </div>
            </div>
            <span class="vault-list-row__count">{{ folder.item_count || 0 }}</span>
            <span class="vault-list-row__count">{{ folder.folder_count || 0 }}</span>
            <span class="vault-list-row__date">{{ folder.created_at | date: 'dd/MM/yyyy' }}</span>
            <div class="vault-list-row__actions" (click)="$event.stopPropagation()">
              <button class="icon-button action-trigger" type="button" (click)="toggleFolderMenu(folder, $event)">
                <mat-icon>more_vert</mat-icon>
              </button>
              <div class="action-dropdown action-dropdown--vault-list" *ngIf="activeFolderMenuId === folder.id" (click)="$event.stopPropagation()">
                <button type="button" (click)="openFolder(folder); closeFolderMenu($event)">
                  <mat-icon>info</mat-icon>
                  <span>Detalhes</span>
                </button>
                <button type="button" (click)="openShareModal('FOLDER', { id: folder.id, name: folder.name }, $event); closeFolderMenu($event)">
                  <mat-icon>share</mat-icon>
                  <span>Compartilhar</span>
                </button>
                <button type="button" class="danger" *ngIf="canDeleteFolder(folder)" (click)="deleteFolder(folder, $event); closeFolderMenu($event)">
                  <mat-icon>delete</mat-icon>
                  <span>Excluir</span>
                </button>
              </div>
            </div>
          </article>
        </div>
      </ng-template>
    </div>
  </ng-template>
</ng-template>

<ng-template #emptyState>
  <section class="empty-state-full">
    <p>Faça login para acessar o ControlSafe.</p>
  </section>
</ng-template>

<div class="modal-backdrop" *ngIf="showVaultModal" (click)="showVaultModal = false">
  <section class="modal-card cp-standard-modal safe-modal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div class="modal-title-wrap">
        <h2>{{ editingVault ? 'Editar cofre' : 'Novo cofre' }}</h2>
        <p class="modal-subtitle">Defina o nome e a descrição do cofre.</p>
      </div>
      <button type="button" class="icon-button" (click)="showVaultModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form [formGroup]="vaultForm" (ngSubmit)="saveVault()" class="cp-modal-body">
      <div class="cp-modal-scroll">
        <div class="safe-form-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
            <mat-label>Nome do cofre</mat-label>
            <input matInput type="text" formControlName="name" placeholder="Digite o nome do cofre">
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field full cp-textarea">
            <mat-label>Descrição</mat-label>
            <textarea matInput formControlName="description" rows="4" placeholder="Descreva a finalidade deste cofre"></textarea>
          </mat-form-field>
        </div>
        <p class="modal-feedback error full" *ngIf="vaultFeedback">{{ vaultFeedback }}</p>
        <div class="modal-footer-actions full">
          <button class="btn outline" type="button" (click)="showVaultModal = false">Cancelar</button>
          <button class="btn primary" type="submit" [disabled]="savingVault">
            {{ savingVault ? 'Salvando...' : 'Salvar cofre' }}
          </button>
        </div>
      </div>
    </form>
  </section>
</div>

<div class="modal-backdrop" *ngIf="showFolderModal" (click)="showFolderModal = false">
  <section class="modal-card cp-standard-modal safe-modal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div class="modal-title-wrap">
        <h2>{{ editingFolder ? 'Editar pasta' : 'Nova pasta' }}</h2>
        <p class="modal-subtitle" *ngIf="currentPathLabel">Caminho: {{ currentPathLabel }}</p>
      </div>
      <button type="button" class="icon-button" (click)="showFolderModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form [formGroup]="folderForm" (ngSubmit)="saveFolder()" class="cp-modal-body">
      <div class="cp-modal-scroll">
        <div class="safe-form-grid">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
            <mat-label>Nome da pasta</mat-label>
            <input matInput type="text" formControlName="name" placeholder="Digite o nome da pasta">
          </mat-form-field>
        </div>
        <p class="modal-feedback error full" *ngIf="folderFeedback">{{ folderFeedback }}</p>
        <div class="modal-footer-actions full">
          <button class="btn outline" type="button" (click)="showFolderModal = false">Cancelar</button>
          <button class="btn primary" type="submit" [disabled]="savingFolder">
            {{ savingFolder ? 'Salvando...' : (editingFolder ? 'Salvar alterações' : 'Salvar pasta') }}
          </button>
        </div>
      </div>
    </form>
  </section>
</div>

<div class="modal-backdrop" *ngIf="showItemModal" (click)="showItemModal = false">
  <section class="modal-card cp-standard-modal safe-modal safe-item-modal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div class="modal-title-wrap">
        <h2>Novo item</h2>
        <p class="modal-subtitle" *ngIf="currentPathLabel">Caminho: {{ currentPathLabel }}</p>
      </div>
      <button type="button" class="icon-button" (click)="showItemModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form [formGroup]="itemForm" (ngSubmit)="saveItem()" class="cp-modal-body">
      <div class="cp-modal-scroll item-create-scroll">
        <div class="item-create-grid safe-form-grid two-columns">
          <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
            <mat-label>Cofre*</mat-label>
            <mat-select formControlName="vault_id">
              <mat-option value="" disabled>Selecione o cofre</mat-option>
              <mat-option *ngFor="let vault of vaults" [value]="vault.id">
                {{ vault.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>Tipo de item*</mat-label>
            <mat-select formControlName="item_type">
              <mat-select-trigger>
                <span class="item-type-trigger">
                  <mat-icon>{{ getItemIcon(selectedItemType) }}</mat-icon>
                  <span>{{ getItemTypeDisplayLabel(selectedItemType) }}</span>
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let type of itemTypes" [value]="type.value">
                <span class="item-type-option">
                  <mat-icon>{{ getItemIcon(type.value) }}</mat-icon>
                  <span>{{ type.label }}</span>
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field">
            <mat-label>{{ titleLabel }}*</mat-label>
            <input matInput type="text" formControlName="title" placeholder="Ex.: AWS Production">
          </mat-form-field>

          <div
            class="item-create-row full"
            *ngIf="selectedItemType === 'LOGIN' || selectedItemType === 'SECURE_NOTE' || selectedItemType === 'DOCUMENT' || selectedItemType === 'API_KEY'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Subtítulo</mat-label>
              <input matInput type="text" formControlName="subtitle" placeholder="Ex.: Console principal">
            </mat-form-field>

            <ng-container *ngIf="selectedItemType === 'LOGIN'">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Link</mat-label>
                <input matInput type="text" formControlName="website_url" placeholder="https://exemplo.com/login">
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="item-inline-icon-btn"
                  aria-label="Abrir link em nova aba"
                  (click)="openItemWebsite()"
                  [disabled]="!itemForm.value.website_url">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </mat-form-field>
            </ng-container>
          </div>

          <div class="item-create-row full" *ngIf="selectedItemType === 'LOGIN' || selectedItemType === 'WIFI'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Usuário*</mat-label>
              <input matInput type="text" formControlName="username" placeholder="Ex.: usuario@empresa.com">
            </mat-form-field>
            <ng-container *ngIf="usesExpiresAt(selectedItemType)">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Expira em</mat-label>
                <input matInput [matDatepicker]="itemExpiresAtPicker" formControlName="expires_at" placeholder="dd/mm/aaaa">
                <mat-datepicker-toggle matSuffix [for]="itemExpiresAtPicker"></mat-datepicker-toggle>
                <mat-datepicker #itemExpiresAtPicker></mat-datepicker>
              </mat-form-field>
            </ng-container>
          </div>

          <ng-container *ngIf="selectedItemType === 'DOCUMENT' || selectedItemType === 'API_KEY'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Expira em</mat-label>
              <input matInput [matDatepicker]="itemExpiresAtPicker" formControlName="expires_at" placeholder="dd/mm/aaaa">
              <mat-datepicker-toggle matSuffix [for]="itemExpiresAtPicker"></mat-datepicker-toggle>
              <mat-datepicker #itemExpiresAtPicker></mat-datepicker>
            </mat-form-field>
          </ng-container>

          <div class="item-create-row full" *ngIf="selectedItemType === 'LOGIN' || selectedItemType === 'WIFI' || selectedItemType === 'CREDIT_CARD'">
            <div class="item-create-field-block item-create-password-cell">
              <div class="item-create-password-row">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field item-create-password-input">
                  <mat-label>{{ secretLabel }}*</mat-label>
                  <input
                    matInput
                    [type]="itemSecretVisible ? 'text' : 'password'"
                    formControlName="secret"
                    placeholder="••••••••••">
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    class="item-inline-icon-btn"
                    aria-label="Mostrar ou ocultar senha"
                    (click)="toggleItemSecretVisibility()">
                    <mat-icon>{{ itemSecretVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                </mat-form-field>

                <button class="btn ghost item-generate-password-btn" type="button" (click)="generateItemPassword()">
                  Gerar senha
                </button>
              </div>
              <div class="password-strength" [attr.data-tone]="itemSecretStrengthTone">
                <span class="password-strength__dot"></span>
                <span>Força da senha: {{ itemSecretStrengthLabel }}</span>
              </div>
            </div>
          </div>

          <ng-container *ngIf="selectedItemType === 'CREDIT_CARD'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tipo do cartão</mat-label>
              <select matNativeControl formControlName="card_type">
                <option value="">Selecione</option>
                <option value="CREDITO">Crédito</option>
                <option value="DEBITO">Débito</option>
              </select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Banco</mat-label>
              <select matNativeControl *ngIf="banks.length; else bankFallback" formControlName="card_bank">
                <option value="">{{ banksLoading ? 'Carregando bancos...' : 'Selecione o banco' }}</option>
                <option *ngFor="let bank of banks" [value]="bank.name">{{ bank.name }}</option>
              </select>
              <ng-template #bankFallback>
                <input matInput type="text" formControlName="card_bank" placeholder="Digite o banco">
              </ng-template>
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número</mat-label>
              <input matInput type="text" formControlName="card_number" placeholder="0000 0000 0000 0000">
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Expiração do cartão</mat-label>
              <input matInput type="month" formControlName="card_expiration">
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="selectedItemType === 'API_KEY'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>API Key produção</mat-label>
              <input matInput type="text" formControlName="api_key_prod">
            </mat-form-field>

            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>API Key homologação</mat-label>
              <input matInput type="text" formControlName="api_key_hml">
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="selectedItemType === 'BANK_ACCOUNT'">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Tipo de conta</mat-label>
              <input matInput type="text" formControlName="bank_account_type">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número de identificação</mat-label>
              <input matInput type="text" formControlName="bank_id_number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número da conta</mat-label>
              <input matInput type="text" formControlName="bank_account_number">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Código SWIFT</mat-label>
              <input matInput type="text" formControlName="bank_swift">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Número IBAN</mat-label>
              <input matInput type="text" formControlName="bank_iban">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>PIN</mat-label>
              <input matInput type="text" formControlName="bank_pin">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>País</mat-label>
              <input matInput type="text" formControlName="bank_country">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Telefone</mat-label>
              <input matInput type="text" formControlName="bank_phone">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
              <mat-label>Endereço da filial</mat-label>
              <input matInput type="text" formControlName="bank_branch_address">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Filial</mat-label>
              <input matInput type="text" formControlName="bank_branch">
            </mat-form-field>
            <mat-form-field appearance="outline" class="digital-field modal-standard-field">
              <mat-label>Gerente da conta</mat-label>
              <input matInput type="text" formControlName="bank_manager">
            </mat-form-field>
          </ng-container>

          <mat-form-field appearance="outline" class="digital-field modal-standard-field full cp-textarea">
            <mat-label>Notas</mat-label>
            <textarea matInput rows="4" formControlName="notes_preview" placeholder="Adicione informações relevantes sobre este item..."></textarea>
          </mat-form-field>

          <div class="item-attachment-dropzone full" *ngIf="requiresAttachmentsForType(selectedItemType)">
            <input #newItemAttachmentInput type="file" class="item-attachment-input" multiple (change)="onNewItemFilesSelected($event)">
            <button
              type="button"
              class="item-attachment-dropzone__surface"
              (click)="newItemAttachmentInput.click()"
              (dragover)="$event.preventDefault()"
              (drop)="$event.preventDefault(); onNewItemFilesSelected($event)"
              aria-label="Adicionar anexos">
              <mat-icon>upload_file</mat-icon>
              <strong>Arraste arquivos aqui ou clique para anexar</strong>
              <span>Opcional para este tipo de item</span>
            </button>
            <div class="item-attachment-list" *ngIf="itemFiles.length">
              <div class="item-attachment-row" *ngFor="let file of itemFiles; let index = index">
                <div class="item-attachment-row__info">
                  <mat-icon>attach_file</mat-icon>
                  <span>{{ file.name }}</span>
                </div>
                <button type="button" class="mini-action" (click)="removeNewItemFile(index)">
                  <mat-icon>close</mat-icon>
                  <span>Remover</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <p class="modal-feedback error full" *ngIf="itemFeedback">{{ itemFeedback }}</p>

        <div class="modal-footer-actions full">
          <button class="btn outline" type="button" (click)="showItemModal = false">Cancelar</button>
          <button class="btn primary" type="submit" [disabled]="savingItem">
            {{ savingItem ? 'Salvando...' : 'Salvar item' }}
          </button>
        </div>
      </div>
    </form>
  </section>
</div>

<div class="modal-backdrop" *ngIf="shareModalVisible" (click)="closeShareModal()">
  <section class="modal-card cp-standard-modal safe-modal" (click)="$event.stopPropagation()">
    <ng-container *ngIf="shareTarget as target">
      <header class="modal-header">
        <div class="modal-title-wrap">
          <h2>Compartilhar {{ target.type === 'VAULT' ? 'cofre' : target.type === 'FOLDER' ? 'pasta' : 'item' }}</h2>
          <p class="modal-subtitle">
            {{ target.name }} · Selecione os usuários que terão acesso.
          </p>
        </div>
        <button type="button" class="icon-button" (click)="closeShareModal()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <form class="cp-modal-body" (ngSubmit)="saveShareGrants()">
        <div class="cp-modal-scroll">
          <ng-container *ngIf="shareCanManage; else shareReadonlyModal">
            <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
              <mat-label>Buscar usuário</mat-label>
              <mat-icon matIconPrefix>search</mat-icon>
              <input
                matInput
                type="search"
                name="shareSearchTerm"
                [(ngModel)]="shareSearchTerm"
                (ngModelChange)="onShareSearchChange($event)"
                placeholder="Digite nome ou e-mail">
            </mat-form-field>

            <div class="share-selected-tags" *ngIf="shareRecipients.length">
              <span class="share-selected-tags__label">Selecionados</span>
              <div class="share-recipient-row" *ngFor="let recipient of shareRecipients">
                <div class="share-recipient-row__email">
                  <strong>{{ recipient.email }}</strong>
                </div>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field share-recipient-row__level">
                  <mat-label>Nível de acesso</mat-label>
                  <mat-select
                    [value]="recipient.access_level"
                    [disabled]="isCurrentUserShareRecipient(recipient.email)"
                    (selectionChange)="updateShareRecipientAccessLevel(recipient.email, $event.value)">
                    <mat-option value="VIEW">Visualizar</mat-option>
                    <mat-option value="EDIT">Editar</mat-option>
                    <mat-option value="MANAGE">Gerenciar</mat-option>
                  </mat-select>
                </mat-form-field>
                <button
                  type="button"
                  class="share-chip share-chip--remove"
                  *ngIf="!isCurrentUserShareRecipient(recipient.email)"
                  (click)="removeShareRecipient(recipient.email)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

            <div class="share-empty share-empty--hint" *ngIf="!shareRecipients.length">
              Selecione um usuário para definir o nível de acesso.
            </div>

            <div class="share-user-list" *ngIf="!usersLoading; else loadingUsers">
              <button
                type="button"
                class="share-user-row"
                *ngFor="let user of filteredShareUsers"
                (click)="toggleShareUser(user.email, true)">
                <div class="share-user-row__content">
                  <strong>{{ user.name || user.email }}</strong>
                  <small>{{ user.email }}</small>
                </div>
                <mat-icon>add</mat-icon>
              </button>

              <div class="share-empty" *ngIf="!filteredShareUsers.length">
                Nenhum usuário disponível para adicionar.
              </div>
            </div>

            <ng-template #loadingUsers>
              <div class="share-empty">Carregando usuários...</div>
            </ng-template>

            <p class="modal-feedback error full" *ngIf="shareFeedback">{{ shareFeedback }}</p>

            <div class="modal-footer-actions full">
              <button class="btn outline" type="button" (click)="closeShareModal()">Cancelar</button>
              <button class="btn primary" type="submit" [disabled]="shareSaving || shareLoading">
                {{ shareSaving ? 'Salvando...' : shareLoading ? 'Carregando...' : 'Salvar compartilhamento' }}
              </button>
            </div>
          </ng-container>

          <ng-template #shareReadonlyModal>
            <div class="share-readonly-note">
              Este usuário pode apenas visualizar o compartilhamento atual.
            </div>

            <div class="share-selected-tags" *ngIf="shareRecipients.length">
              <span class="share-selected-tags__label">Compartilhados</span>
              <div class="share-recipient-row" *ngFor="let recipient of shareRecipients">
                <div class="share-recipient-row__email">
                  <strong>{{ recipient.email }}</strong>
                </div>
                <div class="share-recipient-row__level share-recipient-row__level--readonly">
                  <span>{{ recipient.access_level === 'MANAGE' ? 'Gerenciar' : recipient.access_level === 'EDIT' ? 'Editar' : 'Visualizar' }}</span>
                </div>
              </div>
            </div>

            <div class="share-empty share-empty--hint" *ngIf="!shareRecipients.length">
              Nenhum compartilhamento disponível.
            </div>

            <p class="modal-feedback error full" *ngIf="shareFeedback">{{ shareFeedback }}</p>

            <div class="modal-footer-actions full">
              <button class="btn outline" type="button" (click)="closeShareModal()">Fechar</button>
            </div>
          </ng-template>
        </div>
      </form>
    </ng-container>
  </section>
</div>

<div class="modal-backdrop" *ngIf="deleteTarget" (click)="cancelDeleteTarget()">
  <section class="modal-card cp-standard-modal safe-modal cad-confirm-modal" (click)="$event.stopPropagation()">
    <ng-container *ngIf="deleteTarget as target">
      <header class="modal-header">
        <div class="modal-title-wrap">
          <h2>{{ target.type === 'VAULT' ? 'Excluir cofre' : target.type === 'FOLDER' ? 'Excluir pasta' : 'Excluir item' }}</h2>
          <p class="modal-subtitle">
            {{
              target.type === 'VAULT'
                ? 'Esta ação vai remover o cofre e todos os seus conteúdos.'
                : target.type === 'FOLDER'
                  ? 'A pasta será removida e os itens internos serão mantidos no nível superior.'
                  : 'O item será removido da listagem e do histórico ativo.'
            }}
          </p>
        </div>
        <button type="button" class="icon-button" (click)="cancelDeleteTarget()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <div class="cp-modal-body cad-confirm-modal__body">
        <p>
          Tem certeza que deseja excluir
          <strong>{{ target.name }}</strong>
          ?
        </p>
      </div>

      <footer class="cp-modal__footer">
        <button class="btn outline" type="button" (click)="cancelDeleteTarget()">Cancelar</button>
        <button class="btn primary danger" type="button" [disabled]="deleting" (click)="confirmDeleteTarget()">
          {{ deleting ? 'Excluindo...' : 'Excluir' }}
        </button>
      </footer>
    </ng-container>
  </section>
</div>

<div class="modal-backdrop" *ngIf="showItemDetail" (click)="closeItemDetail()">
  <section class="modal-card cp-standard-modal safe-modal safe-details-modal" (click)="$event.stopPropagation()">
    <ng-container *ngIf="activeItem as item">
      <header class="modal-header">
        <div class="detail-header-left">
          <div class="detail-item-icon" [attr.data-type]="item.item_type">
            <mat-icon>{{ getItemIcon(item.item_type) }}</mat-icon>
          </div>
          <div class="modal-title-wrap">
            <div class="detail-title-line">
              <h2>{{ item.title }}</h2>
              <span class="type-pill" [attr.data-type]="item.item_type">{{ getItemTypeLabel(item.item_type) }}</span>
              <button *ngIf="canFavoriteItem(item)" class="favorite-inline" type="button" (click)="toggleFavorite(item, $event)" [class.inactive]="!item.is_favorite" aria-label="Favoritar item">
                <mat-icon>{{ item.is_favorite ? 'star' : 'star_border' }}</mat-icon>
              </button>
            </div>
            <p class="modal-subtitle">
              <span class="path">{{ item.location_label || itemPath }}</span>
            </p>
          </div>
        </div>
        <div class="detail-header-actions">
          <button *ngIf="canFavoriteItem(item)" type="button" class="icon-button" (click)="toggleFavorite(item, $event)" [class.inactive]="!item.is_favorite" aria-label="Favoritar item">
            <mat-icon>{{ item.is_favorite ? 'star' : 'star_border' }}</mat-icon>
          </button>
          <button *ngIf="canShareActiveItem()" type="button" class="icon-button" (click)="setDetailTab('shares', $event)" aria-label="Compartilhar item">
            <mat-icon>share</mat-icon>
          </button>
          <button type="button" class="icon-button" (click)="closeItemDetail()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </header>

      <nav class="detail-tabs" role="tablist">
        <button type="button" class="detail-tab" [class.active]="detailTab === 'details'" (click)="setDetailTab('details', $event)">
          Detalhes
        </button>
        <button type="button" class="detail-tab" [class.active]="detailTab === 'shares'" (click)="setDetailTab('shares', $event)">
          Compartilhamentos <span class="tab-count">{{ shareRecipients.length }}</span>
        </button>
        <button type="button" class="detail-tab" *ngIf="activeItemCanManage" [class.active]="detailTab === 'history'" (click)="setDetailTab('history', $event)">
          Histórico <span class="tab-count">{{ itemHistoryTotal }}</span>
        </button>
        <button type="button" class="detail-tab" *ngIf="activeItemCanManage" [class.active]="detailTab === 'attachments'" (click)="setDetailTab('attachments', $event)">
          Anexos <span class="tab-count">{{ attachments.length }}</span>
        </button>
      </nav>

      <div class="cp-modal__body item-detail-body">
        <div class="detail-grid">
          <div class="detail-main-column">
            <section class="detail-panel" *ngIf="detailTab === 'details'">
              <div [formGroup]="detailForm">
              <h4>Credenciais</h4>
              <div class="detail-stack">
                <div class="detail-field">
                  <label>Título do item</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else titleView">
                      <input class="detail-text-input" type="text" formControlName="title" placeholder="Título do item">
                    </ng-container>
                    <ng-template #titleView>
                      <span class="detail-static-text">{{ item.title }}</span>
                    </ng-template>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Subtítulo</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else subtitleView">
                      <input class="detail-text-input" type="text" formControlName="subtitle" placeholder="Subtítulo">
                    </ng-container>
                    <ng-template #subtitleView>
                      <span class="detail-static-text">{{ item.subtitle || '—' }}</span>
                    </ng-template>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Usuário</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else usernameView">
                      <input class="detail-text-input" type="text" formControlName="username" placeholder="Usuário">
                    </ng-container>
                    <ng-template #usernameView>
                      <span class="detail-static-text">{{ item.username || '—' }}</span>
                    </ng-template>
                    <button class="mini-action" type="button" (click)="copyToClipboard(detailEditMode ? detailForm.get('username')?.value : item.username)" [disabled]="!(detailEditMode ? detailForm.get('username')?.value : item.username)">
                      <mat-icon>content_copy</mat-icon>
                      <span>Copiar</span>
                    </button>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Senha</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else secretView">
                      <div class="secret-field">
                        <input class="detail-secret-input" [type]="showSecret ? 'text' : 'password'" formControlName="secret" placeholder="Senha">
                      </div>
                    </ng-container>
                    <ng-template #secretView>
                      <div class="secret-field">
                        <span class="secret-mask">{{ showSecret ? activeItemSecret : '••••••••••••' }}</span>
                      </div>
                    </ng-template>
                    <div class="detail-actions">
                      <button class="mini-action" type="button" (click)="toggleSecretVisibility()">
                        <mat-icon>{{ showSecret ? 'visibility_off' : 'visibility' }}</mat-icon>
                        <span>{{ showSecret ? 'Ocultar' : 'Mostrar' }}</span>
                      </button>
                      <button class="mini-action" type="button" (click)="copySecret()" [disabled]="!activeItemSecret">
                        <mat-icon>content_copy</mat-icon>
                        <span>Copiar</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Website</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else websiteView">
                      <input class="detail-text-input" type="text" formControlName="website_url" placeholder="Link do site">
                    </ng-container>
                    <ng-template #websiteView>
                      <ng-container *ngIf="item.website_url; else noItemLink">
                        <a
                          class="detail-link"
                          [href]="getWebsiteHref(item.website_url)"
                          target="_blank"
                          rel="noopener noreferrer"
                          [title]="item.website_url">
                          {{ item.website_url }}
                        </a>
                      </ng-container>
                      <ng-template #noItemLink>
                        <span class="detail-muted">—</span>
                      </ng-template>
                    </ng-template>
                    <button class="mini-action" type="button" (click)="copyToClipboard(detailEditMode ? detailForm.get('website_url')?.value : item.website_url)" [disabled]="!(detailEditMode ? detailForm.get('website_url')?.value : item.website_url)">
                      <mat-icon>content_copy</mat-icon>
                      <span>Copiar</span>
                    </button>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Expira em</label>
                  <div class="detail-value-row">
                    <ng-container *ngIf="detailEditMode; else expiryView">
                      <input class="detail-text-input detail-text-input--date" type="date" formControlName="expires_at">
                    </ng-container>
                    <ng-template #expiryView>
                      <span class="detail-static-text">{{ item.expires_at ? (item.expires_at | date: 'shortDate') : '—' }}</span>
                    </ng-template>
                  </div>
                </div>

                <div class="detail-field">
                  <label>Nota da senha</label>
                  <ng-container *ngIf="detailEditMode; else passwordNoteView">
                    <textarea class="detail-textarea" rows="4" formControlName="notes_preview" placeholder="Adicione uma nota sobre esta senha..."></textarea>
                  </ng-container>
                  <ng-template #passwordNoteView>
                    <p class="notes">{{ item.notes_preview || '—' }}</p>
                  </ng-template>
                </div>

                <p class="detail-feedback" *ngIf="detailFeedback">{{ detailFeedback }}</p>
              </div>
              </div>
            </section>

            <section class="detail-panel" *ngIf="detailTab === 'details' && itemFields.length">
              <div [formGroup]="detailForm">
              <h4>Informações adicionais</h4>
              <div class="detail-stack">
                <div class="detail-field" *ngIf="itemFields.length">
                  <label>Campos extras</label>
                  <div class="extra-field-list">
                    <div class="extra-field" *ngFor="let field of itemFields">
                      <span>{{ field.field_label }}</span>
                      <strong>{{ fieldDisplayValues.get(field.id) || '—' }}</strong>
                    </div>
                  </div>
                </div>

              </div>
              </div>
            </section>

            <section class="detail-panel" *ngIf="detailTab === 'shares'">
              <h4>Compartilhamentos</h4>
              <ng-container *ngIf="shareCanManage; else shareReadonlyDetail">
                <div class="share-detail-head">
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field full detail-search-field">
                    <mat-label>Buscar usuário</mat-label>
                    <mat-icon matIconPrefix>search</mat-icon>
                    <input
                      matInput
                      type="search"
                      name="shareSearchTerm"
                      [(ngModel)]="shareSearchTerm"
                      (ngModelChange)="onShareSearchChange($event)"
                      placeholder="Digite nome ou e-mail">
                  </mat-form-field>
                </div>

                <div class="share-selected-tags" *ngIf="shareRecipients.length">
                  <span class="share-selected-tags__label">Selecionados</span>
                  <div class="share-recipient-row" *ngFor="let recipient of shareRecipients">
                    <div class="share-recipient-row__email">
                      <strong>{{ recipient.email }}</strong>
                    </div>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field share-recipient-row__level">
                      <mat-label>Nível de acesso</mat-label>
                      <mat-select
                        [value]="recipient.access_level"
                        [disabled]="isCurrentUserShareRecipient(recipient.email)"
                        (selectionChange)="updateShareRecipientAccessLevel(recipient.email, $event.value)">
                        <mat-option value="VIEW">Visualizar</mat-option>
                        <mat-option value="EDIT">Editar</mat-option>
                        <mat-option value="MANAGE">Gerenciar</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button
                      type="button"
                      class="share-chip share-chip--remove"
                      *ngIf="!isCurrentUserShareRecipient(recipient.email)"
                      (click)="removeShareRecipient(recipient.email)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>

                <div class="share-empty share-empty--hint" *ngIf="!shareRecipients.length">
                  Selecione um usuário para definir o nível de acesso.
                </div>

                <div class="share-user-list" *ngIf="!usersLoading; else loadingUsers">
                  <button
                    type="button"
                    class="share-user-row"
                    *ngFor="let user of filteredShareUsers"
                    (click)="toggleShareUser(user.email, true)">
                    <div class="share-user-row__content">
                      <strong>{{ user.name || user.email }}</strong>
                      <small>{{ user.email }}</small>
                    </div>
                    <mat-icon>add</mat-icon>
                  </button>

                  <div class="share-empty" *ngIf="!filteredShareUsers.length">
                    Nenhum usuário disponível para adicionar.
                  </div>
                </div>

                <ng-template #loadingUsers>
                  <div class="share-empty">Carregando usuários...</div>
                </ng-template>

                <p class="modal-feedback error full" *ngIf="shareFeedback">{{ shareFeedback }}</p>
                <div class="detail-panel__footer-actions">
                  <button class="btn outline" type="button" (click)="loadItemShareGrants(item.id)">Recarregar</button>
                  <button class="btn primary" type="button" [disabled]="shareSaving || shareLoading" (click)="saveShareGrants()">
                    {{ shareSaving ? 'Salvando...' : shareLoading ? 'Carregando...' : 'Salvar compartilhamento' }}
                  </button>
                </div>
              </ng-container>

              <ng-template #shareReadonlyDetail>
                <div class="share-readonly-note">
                  Somente leitura. Compartilhamentos não podem ser alterados por este usuário.
                </div>
                <div class="share-selected-tags" *ngIf="shareRecipients.length">
                  <span class="share-selected-tags__label">Compartilhados</span>
                  <div class="share-recipient-row" *ngFor="let recipient of shareRecipients">
                    <div class="share-recipient-row__email">
                      <strong>{{ recipient.email }}</strong>
                    </div>
                    <div class="share-recipient-row__level share-recipient-row__level--readonly">
                      <span>{{ recipient.access_level === 'MANAGE' ? 'Gerenciar' : recipient.access_level === 'EDIT' ? 'Editar' : 'Visualizar' }}</span>
                    </div>
                  </div>
                </div>
                <div class="share-empty share-empty--hint" *ngIf="!shareRecipients.length">
                  Nenhum compartilhamento disponível.
                </div>
                <p class="modal-feedback error full" *ngIf="shareFeedback">{{ shareFeedback }}</p>
                <div class="detail-panel__footer-actions">
                  <button class="btn outline" type="button" (click)="loadItemShareGrants(item.id)">Recarregar</button>
                </div>
              </ng-template>
            </section>

            <section class="detail-panel" *ngIf="detailTab === 'history' && activeItemCanManage">
              <h4>Histórico</h4>
              <div class="history-list" *ngIf="itemHistory.length; else noHistory">
                <article class="history-row" *ngFor="let entry of itemHistory">
                  <div class="history-row__main">
                    <strong>{{ entry.event_type }}</strong>
                    <p>{{ entry.event_description || 'Sem descrição' }}</p>
                  </div>
                  <div class="history-row__meta">
                    <span>{{ entry.user_name || entry.user_email || '—' }}</span>
                    <small>{{ entry.created_at | date: 'dd/MM/yyyy HH:mm' }}</small>
                  </div>
                </article>
              </div>
              <ng-template #noHistory>
                <div class="detail-empty" *ngIf="itemHistoryLoading">Carregando histórico...</div>
                <div class="detail-empty" *ngIf="!itemHistoryLoading">Nenhum registro encontrado.</div>
              </ng-template>
              <div class="detail-pagination" *ngIf="itemHistoryTotalPages > 1">
                <button class="mini-action" type="button" (click)="goToItemHistoryPage(itemHistoryPage - 1)" [disabled]="itemHistoryPage <= 1">
                  <mat-icon>chevron_left</mat-icon>
                  <span>Anterior</span>
                </button>
                <div class="detail-pagination__pages">
                  <button
                    *ngFor="let page of itemHistoryPageNumbers"
                    type="button"
                    class="detail-page-dot"
                    [class.active]="itemHistoryPage === page"
                    (click)="goToItemHistoryPage(page)">
                    {{ page }}
                  </button>
                </div>
                <button class="mini-action" type="button" (click)="goToItemHistoryPage(itemHistoryPage + 1)" [disabled]="itemHistoryPage >= itemHistoryTotalPages">
                  <span>Próxima</span>
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            </section>

            <section class="detail-panel" *ngIf="detailTab === 'attachments' && activeItemCanManage">
              <h4>Anexos</h4>
              <div class="attachment-list" *ngIf="attachments.length; else noAttachments">
                <div class="attachment-row" *ngFor="let attachment of attachments">
                  <div class="attachment-row__meta">
                    <mat-icon>attach_file</mat-icon>
                    <div>
                      <strong>{{ attachment.file_name }}</strong>
                      <small>{{ attachment.uploaded_at | date: 'short' }}</small>
                    </div>
                  </div>
                  <button class="mini-action" type="button" (click)="downloadAttachment(attachment)">
                    <mat-icon>download</mat-icon>
                    <span>Baixar</span>
                  </button>
                </div>
              </div>
              <ng-template #noAttachments>
                <div class="detail-empty">Nenhum anexo cadastrado.</div>
              </ng-template>
            </section>
          </div>

          <aside class="detail-side-column">
            <section class="detail-side-card">
              <h4>Informações</h4>
              <div class="detail-info-list">
                <div class="detail-info-row">
                  <span>Tipo</span>
                  <strong class="type-pill" [attr.data-type]="item.item_type">{{ getItemTypeLabel(item.item_type) }}</strong>
                </div>
                <div class="detail-info-row">
                  <span>Criado por</span>
                  <strong>{{ item.created_by_name || '—' }}</strong>
                </div>
                <div class="detail-info-row">
                  <span>Criado em</span>
                  <strong>{{ item.created_at | date: 'dd/MM/yyyy HH:mm' }}</strong>
                </div>
                <div class="detail-info-row">
                  <span>Última modificação</span>
                  <strong>{{ item.updated_at ? (item.updated_at | date: 'dd/MM/yyyy HH:mm') : '—' }}</strong>
                </div>
                <div class="detail-info-row">
                  <span>Último acesso</span>
                  <strong>{{ item.last_access_at ? (item.last_access_at | date: 'short') : '—' }}</strong>
                </div>
                <div class="detail-info-row">
                  <span>Força da senha</span>
                  <div class="detail-strength">
                <div class="strength-dots" [attr.data-tone]="detailPasswordStrengthTone">
                      <span *ngFor="let dot of detailPasswordStrengthDots" class="strength-dot" [class.active]="dot <= detailPasswordStrengthScore"></span>
                    </div>
                    <strong>{{ detailPasswordStrengthLabel }}</strong>
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-side-card">
              <h4>Ações</h4>
              <div class="detail-side-actions">
                <button class="detail-action-btn" type="button" *ngIf="canEditActiveItem()" (click)="detailEditMode ? saveDetailItem() : startDetailEdit($event)">
                  <mat-icon>{{ detailEditMode ? 'save' : 'edit' }}</mat-icon>
                  <span>{{ detailEditMode ? 'Salvar alterações' : 'Editar' }}</span>
                </button>
                <button class="detail-action-btn" type="button" *ngIf="canShareActiveItem()" (click)="setDetailTab('shares', $event)">
                  <mat-icon>share</mat-icon>
                  <span>Compartilhar</span>
                </button>
                <button class="detail-action-btn" type="button" (click)="copySecret()">
                  <mat-icon>key</mat-icon>
                  <span>Copiar senha</span>
                </button>
                <button class="detail-action-btn danger" type="button" *ngIf="canDeleteActiveItem()" (click)="deleteItem(item, $event); closeItemDetail()">
                  <mat-icon>delete</mat-icon>
                  <span>Excluir item</span>
                </button>
              </div>
            </section>
          </aside>
        </div>
      </div>

      <footer class="detail-footer">
        <div class="detail-footer__meta">
          <span>ID do item</span>
          <strong>{{ item.id || '—' }}</strong>
        </div>
        <div class="detail-footer__actions" *ngIf="detailEditMode; else viewFooterActions">
          <button class="btn outline" type="button" (click)="cancelDetailEdit($event)">Cancelar</button>
          <button class="btn primary" type="button" (click)="saveDetailItem()" [disabled]="detailSaving">
            {{ detailSaving ? 'Salvando...' : 'Salvar alterações' }}
          </button>
        </div>
        <ng-template #viewFooterActions>
          <div class="detail-footer__actions">
            <button class="btn outline" type="button" (click)="closeItemDetail()">Fechar</button>
            <button class="btn primary" type="button" (click)="copySecret()" [disabled]="!activeItemSecret">Copiar senha</button>
          </div>
        </ng-template>
      </footer>
    </ng-container>
  </section>
</div>

<div class="copy-toast" *ngIf="copyFeedback">{{ copyFeedback }}</div>
